import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { alignments, justifyContentPosition } from "core/props";

import colors from "core/colors";

import {
    CardsContainer,
    Card,
    IconContainer,
    StyledHeading,
    StyledBodyText,
    PriceContainer,
    StyledPriceSubheading,
    StyledPriceHeading,
    StyledDurationBodyText,
    StyledButton
} from "./styles";

const UnstyledCardsTwoUp = ({
    className,
    cards,
    cardBoxesAlignment = "flex-start",
    cardContentAlignment = "center"
}) => {
    return !cards ? null : (
        <CardsContainer
            cardBoxesAlignment={cardBoxesAlignment}
            className={className}
        >
            {cards.map((card, index) => {
                return (
                    <Card
                        cardContentAlignment={cardContentAlignment}
                        key={index}
                    >
                        {!!card.icons && (
                            <IconContainer>
                                {card.icons.map(icon => icon)}
                            </IconContainer>
                        )}

                        <StyledHeading
                            type="h5"
                            size="sm"
                            alignment={cardContentAlignment}
                        >
                            {card.title}
                        </StyledHeading>

                        <StyledBodyText
                            type="div"
                            size="xl"
                            alignment={cardContentAlignment}
                        >
                            {card.description}
                        </StyledBodyText>

                        {!!card.price && (
                            <PriceContainer>
                                <StyledPriceSubheading
                                    size="sm"
                                    type="div"
                                    alignment={cardContentAlignment}
                                    copyColor={colors.secondary.oolong}
                                >
                                    {!!card.priceSubHeading &&
                                        card.priceSubHeading}
                                </StyledPriceSubheading>
                                <StyledPriceHeading
                                    size="sm"
                                    type="div"
                                    cardContentAlignment={cardContentAlignment}
                                >
                                    ${card.price}
                                </StyledPriceHeading>
                                <StyledDurationBodyText
                                    size="md"
                                    type="div"
                                    alignment={cardContentAlignment}
                                >
                                    {card.priceDuration}
                                </StyledDurationBodyText>
                            </PriceContainer>
                        )}

                        {!!card.buttons &&
                            card.buttons.map((button, index) => {
                                // only show button if button has href:
                                return !!button.href ? (
                                    <StyledButton
                                        key={index}
                                        cardContentAlignment={
                                            cardContentAlignment
                                        }
                                        href={button.href}
                                        width="100%"
                                    >
                                        {button.text}
                                    </StyledButton>
                                ) : null;
                            })}
                    </Card>
                );
            })}
        </CardsContainer>
    );
};

const CardsTwoUp = styled(UnstyledCardsTwoUp)``;

CardsTwoUp.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            icons: PropTypes.array,
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            priceSubheading: PropTypes.string,
            price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            priceDuration: PropTypes.string,
            buttons: PropTypes.arrayOf(
                PropTypes.shape({
                    text: PropTypes.string,
                    href: PropTypes.string
                })
            )
        })
    ),
    cardBoxesAlignment: PropTypes.oneOf(justifyContentPosition),
    cardContentAlignment: PropTypes.oneOf(alignments)
};

export default CardsTwoUp;
